module.exports = __webpack_public_path__ + "img/icon-apple.ca0f74c4.png";